import {
    tss,
} from 'app/tss'

export default tss.withNestedSelectors().create(({
    theme,
}) => {
    return {
        root: {
            display: 'flex',
            height: '100%',
        },
        iconContainer: {
            width: 65,
            display: 'flex',
            justifyContent: 'center',
        },
        icon: {
            width: '70%',
            height: 'auto',
        },
        iconBigger: {
            width: '100%',
        },
        iconSmaller: {
            width: '60%',
        },
        linkContainer: {
            display: 'flex',
            alignItems: 'center',
            '& :hover': {
                color: theme.palette.common.white,
                backgroundColor: theme.palette.primary[1000],
            },
        },
        link: {
            fontWeight: 400,
            textDecoration: 'none',
            color: theme.palette.primary[50],
            borderBottom: '2px solid transparent',
            padding: theme.spacing(0.4, 2, 0, 2),
            boxSizing: 'border-box',
            height: '100%',
            marginBottom: theme.spacing(0.2),
            display: 'flex',
            alignItems: 'center',
        },
        activeLink: {
            '&&': {
                borderBottom: `2px solid ${theme.palette.common.white}`,
                color: theme.palette.common.white,
            },
        },
    }
})
